/* ============================================================
   FRAISE NOIRE — LA HAUTEUR DE L'EN-TÊTE

   Le héros de l'accueil occupe l'écran entier sur téléphone. Mais il ne
   commence pas en haut de l'écran : le bandeau d'annonce et la barre de
   navigation sont au-dessus de lui. Un héros haut de `100dvh` dépassait donc
   le bas de l'écran d'autant — et c'est là que se trouvaient les deux
   mannequins, invisibles sans défiler.

   On mesure ce qui occupe le haut et on l'écrit dans `--h-entete`, que le CSS
   retranche. Mesuré plutôt que codé en dur : le bandeau d'annonce peut être
   désactivé depuis l'admin, et sa hauteur change avec la longueur du texte.
   ============================================================ */
(() => {
  'use strict';

  const racine = document.documentElement;

  function mesurer() {
    const heros = document.querySelector('.hero--shot');
    if (!heros) return;                       // cette page n'a pas de héros plein écran
    const haut = Math.max(0, Math.round(heros.getBoundingClientRect().top + scrollY));
    racine.style.setProperty('--h-entete', haut + 'px');
  }

  // au chargement, puis à chaque changement de taille ou d'orientation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mesurer, { once: true });
  } else {
    mesurer();
  }
  addEventListener('load', mesurer);
  addEventListener('resize', mesurer, { passive: true });
  addEventListener('orientationchange', mesurer);

  /* Le bandeau d'annonce défile ses messages : sa hauteur peut changer après
     coup. On observe donc l'en-tête plutôt que de mesurer une seule fois. */
  if (window.ResizeObserver) {
    const cible = document.querySelector('.nav') || document.querySelector('header');
    if (cible) new ResizeObserver(mesurer).observe(cible);
  }
})();
